import { render, staticRenderFns } from "./AiDiagnosisTab.vue?vue&type=template&id=936e3124"
import script from "./AiDiagnosisTab.vue?vue&type=script&lang=js"
export * from "./AiDiagnosisTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports